<style lang="less" scoped>
.home-container {
  padding: 24px 0;
  background-color: #fcfbfb;
}
.box {
  background-color: #ffffff;
  padding: 32px 42px;
}
</style>
<template>
  <div class="home-container">
    <div class="container-fixed">
      <div class="box">
        <ProductList
          :filter="filter"
          :sort="sort"
          :currentPage="currentPage"
          @change="handleListChange" />
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

import ProductList from '@/components/ProductList'
import ProductListHandler from '../mixins/ProductListHandler'
const { mapGetters: cateMapGetters, mapState: cateMapState } = createNamespacedHelpers('activityCate')

export default {
  mixins: [ProductListHandler],
  data: function () {
    return {
    }
  },
  components: {
    ProductList,
  },
  methods: {
  },
  created() {
    this.$store.dispatch('activityCate/setTopCateId', '')
  }
}
</script>

